
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryCoordinatingGroups, QueryCoordinatingGroupsResponse, CoordinatingGroup } from "@/api/dtos";
import { useMemo } from "react";
import useCachedDataQuery from '@/hooks/api/useCachedDataQuery';
import { AppSettings } from "@/AppSettings";

const getAdditionalState = (response?: SWRResponse<QueryCoordinatingGroupsResponse, QueryCoordinatingGroupsResponse>) => ({
    idMap: !!response?.data?.data?.length ? response?.data?.data?.reduce<Record<number, CoordinatingGroup>>((a, b) => {
        if (!b?.id) {
            return a;
        }
        
        a[b.id] = b;

        return a;
    },{}) : undefined
});

const sortData = (a: CoordinatingGroup, b: CoordinatingGroup) => a.name! > b.name! ? 1 : -1;

export const useCoordinatingGroups = (query?: Partial<CoordinatingGroup>, configuration?: SWRConfiguration | undefined) => {
    return useCachedDataQuery(QueryCoordinatingGroups, { sortData, getAdditionalState, channel: AppSettings.channels.coordinatingGroup }, query, configuration);
}

export default useCoordinatingGroups;